package com.milta.core.localization.translations.de

import com.milta.core.localization.WebDashboardStrings

// MIL-48 — English-content placeholder, consistent with the rest of this `de` package (see De.kt
// remarks) apart from `settings` (MIL-53, genuinely translated).
internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Refresh",
    expandedStopsTitle = "Stops",
    stopStatusWaitingLabel = "Waiting",
    stopStatusFailedLabel = "Not delivered",
)
